import dayjs from 'dayjs';
import { List, ListItemButton } from '@mui/material';
import ConductIcon from './ConductIcon';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

function getBg(naziv) {
  if (naziv.startsWith('Nez')) return 'red-bg';
  if (naziv.startsWith('Dob')) return 'orange-bg';
  return 'green-bg';
}

export default function Conduct({ conduct = [] }) {
  return (
    <div>
      <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {conduct.map((item, index) => (
                <ListItemButton key={index} sx={{ p: 0, m: 0 }}>
                  <div className="main-flex-container">
                    <ConductIcon nazivtipa={item.nazivtipa} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{item.nazivtipa}</div>
                      </div>
                      <div className="bottom-flex-container w-100">
                        <div className={'ocjena-vladanje ' + getBg(item.naziv)} style={{ marginTop: 3 }}>
                          {item.naziv}
                        </div>
                      </div>
                      <div className="bottom-flex-container w-100" style={{ marginTop: 5 }}>
                        <div>{item.napomena || ''}</div>
                      </div>
                    </div>
                    <div className="date-container">
                      <div>{getDan(item.datum)}</div>
                      <div>{getMjesec(item.datum)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
      </div>
    </div>
  );
}
